import {
    OBSERVACIO_PERIODE_SELECCIONAT,
    OBSERVACIO_SELECCIONADA,
    OBSERVACIO_OBTENIR,
    OBSERVACIO_OBTENIR_EN_CURS,
    OBSERVACIO_OBTENIR_ESTATS,
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI,
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_FINALITZADA,
    OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_EN_CURS,
    OBSERVACIO_DATA_SELECCIONADA,
    OBSERVACIO_FORMULARI_OBTENIR_DATA_HORA,
    OBSERVACIO_FORMULARI_MODIFICAR_DATA_HORA,
    OBSERVACIO_FORMULARI_MODIFICAR_VALOR,
    OBSERVACIO_INICIALITZAR,
    OBSERVACIO_FORMULARI_INICIALITZAR,
    OBSERVACIO_FORMULARI_COMPROVAR,
    OBSERVACIO_FORMULARI_INSERIR_EN_CURS,
    OBSERVACIO_FORMULARI_INSERIR_FINALITZADA,
    OBSERVACIO_FORMULARI_IGNORAR_FILTRES_COHERENCIA_PER_VARIABLE,
    OBSERVACIO_FORMULARI_SELECCIONAR_VALOR_INAPRECIABLE,
    OBSERVACIO_EXPORTACIO_INICIALITZAR,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_EN_CURS,
    OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_FINALITZAT,
    ESTACIO_OBTENIR,
    ESTACIO_SELECCIONADA
} from './actionTypes';

import { convertirMomentATextEnUTC, convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../commons/gestioDates';
import { ordenarAlfabeticamentPerAtributNom } from '../commons/ordenacio';

import { obtenirCodiMoment, obtenirNomMoment,
    obtenirHoraObservacioDeMomentPerDefecte } from '../components/commons/periodes';
import { crearNotificacioSuccess, crearNotificacioWarning, crearNotificacioNoShanModificatValorsAlFormulari } from '../commons/notificacio';

import { fetchEstacionsActives, fetchObservacionsVariablesFormulari, fetchObservacionsMapa, fetchEstats,
    fetchObservacioFormulariEnviar,
    fetchExportacioObservacions, fetchEstacionsActivesPeriode } from '../commons/consultesServidor';

import obtenirEstacioSeleccionada from '../selectors/selector_estacio_per_codi';

import { rutaObservacions } from '../routes/routeConstants';

import { errorConsultaServidor } from './error';
import { obtenirDataHoraActualUTC } from './data';

export const onEnterObservacio = () => {
    return (dispatch, getState) => {
        dispatch(obtenirDataHoraActualUTC())
            .then(() => {
                const dataActualServidorText = getState().dataActual;
                const dataSeleccionadaText = getState().observacio.dataSeleccionada;

                let dataSeleccionadaObservacions;
                if (dataSeleccionadaText) {
                    dataSeleccionadaObservacions = convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD);
                } else {
                    dataSeleccionadaObservacions = convertirTextAMomentUTC(dataActualServidorText);
                }

                dispatch(seleccionarDataConsultaMapa(dataSeleccionadaObservacions));
            });
    };
};

export const onEnterObservacioCrearEditar = () => {
    return (dispatch, getState) => {
        const estacioSeleccionada = obtenirEstacioSeleccionada(getState());
        const horaMomentSeleccionat = getState().observacio.periodeSeleccionat;
        const dataSeleccionadaAsText = getState().observacio.dataSeleccionada;

        const dataSeleccionada = convertirTextAMomentUTC(dataSeleccionadaAsText, MASCARA_YYYYMMDD);
        return dispatch(obtenirObservacionsVariablesFormulari(estacioSeleccionada, horaMomentSeleccionat, dataSeleccionada));
    };
};

export const onEnterObservacioExportacio = () => {
    return dispatch => {
        dispatch(obtenirDataHoraActualUTC());
        dispatch(observacioExportacioInicialitzar());
    };
};

//S'informa de la modificació de l'estació seleccionada al llistat de l'usuari
export function seleccioEstacio(codiEstacio) {
    return dispatch => {
        return dispatch(seleccionarEstacioIobtenirEstatsObservacions(codiEstacio))
            .catch(errorServidor => {
                dispatch(errorConsultaServidor(errorServidor));
            });
    };
}

/**
 *
 * @param estacioSeleccionada
 * @param nomMoment
 * @param dataConsulta {Moment}
 * @returns {Function}
 */
export function obtenirObservacionsVariablesFormulari(estacioSeleccionada, nomMoment, dataConsulta) {
    const codiMoment = obtenirCodiMoment(nomMoment);

    return (dispatch) => {
        dispatch(obtenirObservacionsVariablesFormulariEnCurs());
        return fetchObservacionsVariablesFormulari(estacioSeleccionada.codi, codiMoment, dataConsulta)
            .then((dades) => {
                dispatch(obtenirVariablesFormulari(dades.variables, estacioSeleccionada));
                dispatch(observacioObtenirDataHoraFormulari(dades.dataHoraObservacio));

                if (!dades.dataHoraObservacio) {
                    const dataHoraObservacioPerDefecte = obtenirHoraObservacioDeMomentPerDefecte(dataConsulta, nomMoment);
                    dispatch(observacioModificarDataHoraFormulari(dataHoraObservacioPerDefecte));
                }
                dispatch(obtenirObservacionsVariablesFormulariFinalitzada());
            },(errorServidor) => {
                dispatch(obtenirObservacionsVariablesFormulariFinalitzada());
                dispatch(errorConsultaServidor(errorServidor));
            });
    };
}

const obtenirObservacionsVariablesFormulariEnCurs = () => (
    {
        type: OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_EN_CURS
    }
);

const obtenirObservacionsVariablesFormulariFinalitzada = () => (
    {
        type: OBSERVACIO_OBTENIR_VARIABLES_FORMULARI_FINALITZADA
    }
);

/**
 * S'informa de la modificació del periode d'observacions a visualitzar.
 *
 * @param periode {String} nou periode seleccionat
 * @returns {{type, periodeSeleccionat}|*}
 */
export function selecioPeriodeObservacio(periode) {
    return {
        type: OBSERVACIO_PERIODE_SELECCIONAT,
        periodeSeleccionat: periode
    };
}

/**
 * S'informa de l'estació seleccionada al mapa, per visualitzar-ne l'observació
 * @param codiEstacioSeleccionada
 * @returns {type: OBSERVACIO_SELECCIONADA,codiEstacioObservacioSeleccionada: {String}}
 */
export function seleccioObservacio(codiEstacioObservacioSeleccionada) {
    return {
        type: OBSERVACIO_SELECCIONADA,
        codiEstacioObservacioSeleccionada
    };
}

/**
 *
 * @param dataSeleccionada {Moment}
 * @returns {*}
 */
export function seleccionarDataConsultaMapa(dataSeleccionada) {

    return function(dispatch) {
        if (!dataSeleccionada) {
            console.error('No s\'ha seleccionat data.');
            return;
        }

        dispatch(seleccionarData(dataSeleccionada));

        return Promise.all([
            dispatch(obtenirObservacionsMapa(dataSeleccionada)),
            dispatch(obtenirEstacionsActives(dataSeleccionada))
        ]).catch(errorServidor => {
            dispatch(errorConsultaServidor(errorServidor));
        });
    };
}

/**
 *
 * @param dataHoraObservacioNou {Moment}
 * @returns {{type: OBSERVACIO_FORMULARI_MODIFICAR_DATA_HORA, dataHoraObservacioNou: String}}
 */
export function observacioModificarDataHoraFormulari(dataHoraObservacioNou) {
    const dataHoraObservacioNouAsText = dataHoraObservacioNou ? convertirMomentATextEnUTC(dataHoraObservacioNou) : null;

    return {
        type: OBSERVACIO_FORMULARI_MODIFICAR_DATA_HORA,
        dataHoraObservacioNou: dataHoraObservacioNouAsText
    };
}

export function observacioModificarValorFormulari(idVariable, valor) {

    return (dispatch, getState) => {
        const estacio = obtenirEstacioSeleccionada(getState());
        const accio = {
            type: OBSERVACIO_FORMULARI_MODIFICAR_VALOR,
            idVariable,
            valor,
            estacio
        };

        dispatch(accio);
    };
}

const shaModificatDataHoraObservacio = (dataHoraObservacioNou, dataHoraObservacio) => {
    return dataHoraObservacioNou !== undefined && dataHoraObservacioNou !== dataHoraObservacio;
};

const crearObjecteValorAInserir = (idEstacioVariableMoment, valor, diesExtra, codiAtribut = null) => {
    return {
        idEstacioVariableMoment,
        valor,
        codiAtribut,
        diesExtra
    };
};

/*
 * Funció auxiliar que revisa si alguna de les variables conté errors.
 * Si és així, aleshores es returna true.
 ***/
const revisarSiExisteixenErrorsAlFormulari = (formulari) => {

    const variables = formulari.variables;
    let formulariConteErrors = false;
    const variableConteErrors = variable => variable.errors && variable.errors.length > 0 && !variable.ignorarFiltresCoherencia;

    Object.keys(variables).forEach(indexGrup => {
        const grupConteErrors = variables[indexGrup].some(variableConteErrors);
        formulariConteErrors = formulariConteErrors || grupConteErrors;
    });

    return formulariConteErrors;
};

const usuariNoHaOmplertValorVariable = (variable) => {
    return (variable.valorNou === null || (variable.valorNou === undefined && (variable.valor === undefined || variable.valor === null)));
};

const usuariHaOmplertValorPrecipitacioTotal24hComInapreciable = (variable) => {
    return variable.esValorInapreciable;
};

const validarInsercioCasosEspecials = (variable) => {

    const ID_TEMPERATURA_MAXIMA = 4;
    const ID_TEMPERATURA_MINIMA = 6;
    const ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_PLUVIOMETRIC = 34;

    const casosEspecials = {
        temperaturaMaxima: () => {
            return {valor: '-999', codiAtribut: '-999'};
        },
        temperaturaMinima: () => {
            return {valor: '-999', codiAtribut: '-999'};
        },
        precipitacioTotalDarreres24hDiaPluviometric: () => {
            return {valor: '-999', codiAtribut: '-1'};
        },
        precipitacioTotalDarreres24hDiaPluviometricInapreciable: () => {
            return {valor: '0.0', codiAtribut: '-3'};
        },
        obtenirVariableValidada: (variable, valorNou, codiAtribut) => {
            const variableValidada = {...variable};
            variableValidada.valorNou = valorNou;
            variableValidada.codiAtribut = codiAtribut;

            return variableValidada;
        },
        inicialitzarCodiAtribut: variable => {
            const variableValidada = {...variable};
            variableValidada.codiAtribut = null;
            return variableValidada;
        }
    };

    if (variable.idVariable === ID_TEMPERATURA_MAXIMA) {
        let variableValidada;

        if (usuariNoHaOmplertValorVariable(variable)) {
            const casTMax = casosEspecials.temperaturaMaxima(variable);
            variableValidada = casosEspecials.obtenirVariableValidada(variable, casTMax.valor, casTMax.codiAtribut);
        } else {
            variableValidada = casosEspecials.inicialitzarCodiAtribut(variable);
        }

        return variableValidada;
    }

    if (variable.idVariable === ID_TEMPERATURA_MINIMA) {
        let variableValidada;

        if (usuariNoHaOmplertValorVariable(variable)) {
            const casTMin = casosEspecials.temperaturaMinima(variable);
            variableValidada = casosEspecials.obtenirVariableValidada(variable, casTMin.valor, casTMin.codiAtribut);
        } else {
            variableValidada = casosEspecials.inicialitzarCodiAtribut(variable);
        }

        return variableValidada;
    }

    if (variable.idVariable === ID_PRECIPITACIO_TOTAL_DARRERES_24H_DIA_PLUVIOMETRIC) {
        let variableValidada;

        // El correcte funcionament d'aquest codi depèn de l'ordre d'aquest IF ELSE, així que si es modifica, modifica el comportament de l'aplicació
        if (usuariHaOmplertValorPrecipitacioTotal24hComInapreciable(variable)) {
            const casPrecipitacioDarreres24hInapreciable = casosEspecials.precipitacioTotalDarreres24hDiaPluviometricInapreciable(variable);
            variableValidada = casosEspecials.obtenirVariableValidada(variable, casPrecipitacioDarreres24hInapreciable.valor, casPrecipitacioDarreres24hInapreciable.codiAtribut);
        } else if(usuariNoHaOmplertValorVariable(variable)) {
            const casPrecipitacioDarreres24h = casosEspecials.precipitacioTotalDarreres24hDiaPluviometric(variable);
            variableValidada = casosEspecials.obtenirVariableValidada(variable, casPrecipitacioDarreres24h.valor, casPrecipitacioDarreres24h.codiAtribut);
        } else {
            variableValidada = casosEspecials.inicialitzarCodiAtribut(variable);
        }

        return variableValidada;
    }

    return variable;
};

const shaModificatVariablePerLaplicacioIUsuariNoVolEliminar = (variableValidada, variable) => {
    return variableValidada !== variable && variable.valorNou !== null;
};

const shaSeleccionatPrecipitacioTotal24hInapreciable = (variable) => {
    return variable.codiAtribut === '-3' && variable.valorNou === '0.0';
};

const obtenirValorsAInserir = (variablesFormulari, dataHoraModificada) => {
    let valors = [];
    let numVariablesObligatoriesSenseOmplir = 0;

    // Per a cada grup
    Object.keys(variablesFormulari).forEach((nomGrupVariables) => {
        const grupVariables = variablesFormulari[nomGrupVariables];

        // Per a cada variable
        grupVariables.forEach((variable) => {
            const variableValidada = validarInsercioCasosEspecials(variable);

            if (shaModificatVariablePerLaplicacioIUsuariNoVolEliminar(variableValidada, variable) && shaSeleccionatPrecipitacioTotal24hInapreciable(variable)) {
                numVariablesObligatoriesSenseOmplir ++;
            }

            //Agafem les dades de la variable
            const { idEstacioVariableMoment, valor, valorNou, diesExtra, codiAtribut } = variableValidada;

            if (valor !== undefined) { //s'està editant
                if (dataHoraModificada) { //si s'ha modificat l'hora d'observació

                    const valorAInserir = (valorNou !== undefined) ? valorNou : valor; //si he afegit un nou valor, encara que sigui null
                    valors.push(crearObjecteValorAInserir(idEstacioVariableMoment, valorAInserir, diesExtra, codiAtribut));
                } else if (valor !== valorNou && valorNou !== undefined) { //no s'ha modificat l'hora d'observació i s'ha afegit un valor que és diferent a l'antic

                    valors.push(crearObjecteValorAInserir(idEstacioVariableMoment, valorNou, diesExtra, codiAtribut));
                }
            } else if (valorNou !== undefined && valorNou !== null) { //si he afegit un valor nou i aquest no és null

                valors.push(crearObjecteValorAInserir(idEstacioVariableMoment, valorNou, diesExtra, codiAtribut));
            }
        });
    });

    // l'usuari no havia modificat cap valor.
    //De tots els valors afegits (per l'usuari o per lògica de l'aplicació), es mira únicament els modificats per l'usuari.
    if ((valors.length - numVariablesObligatoriesSenseOmplir) === 0) {
        return null;
    }

    return valors;
};

export const observacioFormulariEnviar = (dataHoraObservacio, dataHoraObservacioNou, variablesFormulari, routerHistory) => {

    return (dispatch, getState) => {

        // Construïm l'array de valors
        let valors = [];

        // Calculem si s'ha modificat la data/hora donat que en aquest cas s'han d'enviar els valors informats prèviament
        const dataHoraModificada = shaModificatDataHoraObservacio(dataHoraObservacioNou, dataHoraObservacio);
        const dataHoraObservacioAEnviar = dataHoraModificada ? dataHoraObservacioNou : dataHoraObservacio;

        if (!dataHoraObservacioAEnviar) {
            // En cas que l'usuari no hagi introduit cap hora d'observació
            const notificacioHoraObservacioObligatoriaAdvertencia = 'S\'ha d\'introduir l\'hora de l\'observació.';
            crearNotificacioWarning(notificacioHoraObservacioObligatoriaAdvertencia);
            return;
        }

        // Comprovem si el formulari conté errors
        dispatch(checkObservacioFormulariEnviar());
        const statePosteriorAFerElCheckDelFormulari = getState();
        const formulariPosteriorAFerElCheck = statePosteriorAFerElCheckDelFormulari.observacio.formulari;
        const conteError = revisarSiExisteixenErrorsAlFormulari(formulariPosteriorAFerElCheck);

        if (conteError) {
            const notificacioErrorDadesCoherenciesAdvertencia = 'Les dades inserides contenen errors de coherència.';
            crearNotificacioWarning(notificacioErrorDadesCoherenciesAdvertencia);
            return;
        }

        valors = obtenirValorsAInserir(variablesFormulari, dataHoraModificada);

        if (valors === null) { //En el cas de que no s'hagi realitzat cap canvi a l'observació, s'informa l'usuari.
            crearNotificacioNoShanModificatValorsAlFormulari();
            return;
        }

        // En el cas de que hi hagi al menys un valor nou/modificat, hem de realitzar el fetch
        const dadesAEnviar = {
            dataHoraObservacio: dataHoraObservacioAEnviar,
            valors
        };

        dispatch(peticioInserirObservacioEnCurs());

        return fetchObservacioFormulariEnviar(dadesAEnviar)
            .then(() => {
                dispatch(peticioInserirObservacioFinalitzada());
                routerHistory.push(rutaObservacions);

                // S'ha d'actualitzar els estats de les observacions de l'estació seleccionada pels colors del calendari
                const codiEstacioSeleccionadaActualment = getState().observacio.estacio.codiSeleccionada;
                dispatch(obtenirEstatsObservacions(codiEstacioSeleccionadaActualment));

                const notificacioCrearObservacioExit = {
                    titol: 'Observació inserida correctament',
                    descripcio: generarMissatgePerUsuariDespresDeInserirObservacio(statePosteriorAFerElCheckDelFormulari)
                };
                crearNotificacioSuccess(notificacioCrearObservacioExit.titol,
                    notificacioCrearObservacioExit.descripcio);
            },(errorServidor) => {
                dispatch(peticioInserirObservacioFinalitzada());
                const notificacioCrearObservacioError = 'Error inserint l\'observació';
                dispatch(errorConsultaServidor(errorServidor, notificacioCrearObservacioError));
            });

    };
};

export function inicialitzaObservacio() {
    return {
        type: OBSERVACIO_INICIALITZAR
    };
}

export function observacioFormulariInicialitzar() {
    return {
        type: OBSERVACIO_FORMULARI_INICIALITZAR
    };
}

export function observacioIgnorarFiltresCoherenciaPerVariable(idVariable, valorCheckbox) {
    return {
        type: OBSERVACIO_FORMULARI_IGNORAR_FILTRES_COHERENCIA_PER_VARIABLE,
        idVariable,
        valorCheckbox
    };
}

export const observacioSeleccionarValorInapreciable = (idVariable, valorCheckbox) => {
    return {
        type: OBSERVACIO_FORMULARI_SELECCIONAR_VALOR_INAPRECIABLE,
        idVariable,
        valorCheckbox
    };
};

function checkObservacioFormulariEnviar() {
    return {
        type: OBSERVACIO_FORMULARI_COMPROVAR
    };
}

export function observacioExportacioInicialitzar() {
    return {
        type: OBSERVACIO_EXPORTACIO_INICIALITZAR
    };
}

/**
 * S'informa de la modificació de les observacions de l'exportació.
 *
 * @param observacions {Object} Estructura de observacions provinent del servidor
 * @returns {{type, observacions}|*}
 */
const observacioExportacioObtenirObservacions = (observacions, dataInici, dataFi, estacioSeleccionada) => {
    return {
        type: OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS,
        observacions,
        dataInici,
        dataFi,
        estacioSeleccionada
    };
};

/**
 * Llença l'acció que indica que la petició per obtenir les observacions d'una exportació està en curs.
 */
const peticioObservacioExportacioEnCurs = () => {
    return {
        type: OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_EN_CURS
    };
};

/**
 * Es llença un cop s'ha acabat la petició al servidor.
 */
const peticioObservacioExportacioFinalitzat = () => {
    return {
        type: OBSERVACIO_EXPORTACIO_OBTENIR_OBSERVACIONS_FINALITZAT
    };
};

/**
 * Consulta les observacions d'una exportació a servidor i llança les accions
 * corresponents depenent del resultat d'aquesta consulta
 *
 * @returns {*}
 */
export const obtenirObservacionsExportacio = (dataInici, dataFi) => {

    return dispatch => {
        dispatch(observacioExportacioInicialitzar());
        dispatch(peticioObservacioExportacioEnCurs());

        return fetchExportacioObservacions(dataInici, dataFi).then(
            observacions => {
                const dataIniciAsText = dataInici.format(MASCARA_YYYYMMDD);
                const dataFiAsText = dataFi.format(MASCARA_YYYYMMDD);
                dispatch(observacioExportacioObtenirObservacions(observacions, dataIniciAsText, dataFiAsText));
                dispatch(peticioObservacioExportacioFinalitzat());
            },
            (errorServidor) => {
                dispatch(peticioObservacioExportacioFinalitzat());
                const notificacioObtenirObservacionsExportacioError = 'Error obtenint les observacions';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirObservacionsExportacioError));
            }
        );
    };
};

/**
 * Consulta les observacions d'una exportació a servidor i llança les accions
 * corresponents depenent del resultat d'aquesta consulta
 *
 * @returns {*}
 */
export const obtenirObservacionsExportacioPerEstacio = (dataInici, dataFi, idEstacio) => {

    return dispatch => {
        dispatch(observacioExportacioInicialitzar());
        dispatch(peticioObservacioExportacioEnCurs());

        return fetchExportacioObservacions(dataInici, dataFi, idEstacio).then(
            observacions => {
                const dataIniciAsText = dataInici.format(MASCARA_YYYYMMDD);
                const dataFiAsText = dataFi.format(MASCARA_YYYYMMDD);
                dispatch(observacioExportacioObtenirObservacions(observacions, dataIniciAsText, dataFiAsText, (observacions.estacions !== undefined && Object.keys(observacions.estacions).length > 0) ? parseInt(Object.keys(observacions.estacions)[0], 10) : null));
                dispatch(peticioObservacioExportacioFinalitzat());
            },
            (errorServidor) => {
                dispatch(peticioObservacioExportacioFinalitzat());
                const notificacioObtenirObservacionsExportacioError = 'Error obtenint les observacions';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirObservacionsExportacioError));
            }
        );
    };
};

/**
 * Consulta les estacions actives per un periode de temps determinat
 *
 * @param {Moment} data inici de la consulta
 * @param {Moment} data Fi de la consulta
 * @returns {*}
 */
export const obtenirEstacionsActivesExportacio = (dataInici, dataFi) => {

    return dispatch => {
        dispatch(observacioExportacioInicialitzar());
        dispatch(peticioObservacioExportacioEnCurs());

        return fetchEstacionsActivesPeriode(dataInici, dataFi).then(
            estacions => {
                const dataIniciAsText = dataInici.format(MASCARA_YYYYMMDD);
                const dataFiAsText = dataFi.format(MASCARA_YYYYMMDD);
                dispatch(observacioExportacioObtenirObservacions(estacions, dataIniciAsText, dataFiAsText));
                dispatch(peticioObservacioExportacioFinalitzat());
            },
            (errorServidor) => {
                dispatch(peticioObservacioExportacioFinalitzat());
                const notificacioObtenirObservacionsExportacioError = 'Error obtenint les estacions actives per el periode de temps definit';
                dispatch(errorConsultaServidor(errorServidor, notificacioObtenirObservacionsExportacioError));
            }
        );
    };
};


/**
 *
 * @param dataConsulta {Moment} data consulta al inici del dia.
 * @returns {Function}
 */
function obtenirEstacionsActives(dataConsulta) {

    return (dispatch, getState) => {

        return fetchEstacionsActives(dataConsulta)
            .then((estacionsUsuari) => {
                const estacionsOrdenadesPerNom = estacionsUsuari.sort(ordenarAlfabeticamentPerAtributNom);
                //Guardar les estacions obtingudes al store.
                dispatch(obtenirEstacions(estacionsOrdenadesPerNom));

                //Per si el que retornar el fetch esta buit
                if (estacionsOrdenadesPerNom.length === 0) {
                    dispatch(estacioSeleccionada(null));
                    dispatch(obtenirEstats([]));
                    return;
                }

                let codiEstacioSeleccionadaActualment;

                if (getState().observacio && getState().observacio.estacio) {
                    codiEstacioSeleccionadaActualment = getState().observacio.estacio.codiSeleccionada;
                }

                if (estacionsOrdenadesPerNom.some(estacio => estacio.codi === codiEstacioSeleccionadaActualment)) {
                    return;
                }

                //Es crida al action creator indicant que s'ha seleleccionat(simulant) una estacio.
                return dispatch(seleccionarEstacioIobtenirEstatsObservacions(estacionsOrdenadesPerNom[0].codi));
            },(errorServidor) => {
                dispatch(obtenirEstacions([]));
                dispatch(estacioSeleccionada(null));
                dispatch(obtenirEstats([]));
                throw errorServidor;
            });
    };
}

function seleccionarEstacioIobtenirEstatsObservacions(codiEstacio) {

    return (dispatch) => {
        dispatch(estacioSeleccionada(codiEstacio));
        return dispatch(obtenirEstatsObservacions(codiEstacio));
    };
}

//obtenirEstacionsActives: Retorna l'objecte que rebrà el reducer amb les estacions d'un usuari
function obtenirEstacions(dadesEstacions) {
    return {
        type: ESTACIO_OBTENIR,
        dadesEstacions
    };
}

function estacioSeleccionada(codiEstacio) {
    return {
        type: ESTACIO_SELECCIONADA,
        codiEstacio
    };
}

/**
 * S'informa de la modificació del dia seleccionat (dataSeleccionada) i es recuperen els estats
 * de les observacions des del dia actual fins el 30 dies anteriors (estatsObservacions).
 * @param codi {String} codi de l'estació per la qual es volen consultar els estats de les observacions
 * @returns {Function}
 */
function obtenirEstatsObservacions(codiEstacio) {

    return (dispatch) => {
        return fetchEstats(codiEstacio)
            .then(
                estatsObservacions => dispatch(obtenirEstats(estatsObservacions)),
                errorServidor => { throw errorServidor; }
            );
    };
}

/*Totes les observacions a visualiztar (amb les variables que es mostren al mapa)*/
function obtenirObservacionsMapa(dataSeleccionada) {
    return function(dispatch) {
        dispatch(peticioObtenirObservacionsEnCurs());

        return fetchObservacionsMapa(dataSeleccionada)
            .then(observacions => dispatch(obtenirObservacions(observacions)),
                (errorServidor) => {
                    dispatch(obtenirObservacions({data: dataSeleccionada, observacions: []}));
                    throw errorServidor;
                });
    };
}

function obtenirVariablesFormulari(variables, estacio) {
    return {
        type: OBSERVACIO_OBTENIR_VARIABLES_FORMULARI,
        variables,
        estacio
    };
}

function observacioObtenirDataHoraFormulari(dataHoraObservacio) {
    return {
        type: OBSERVACIO_FORMULARI_OBTENIR_DATA_HORA,
        dataHoraObservacio
    };
}

//obtenirObservacionsMapa: Retorna l'objecte que rebrà el reducer amb les dades de les observacions a visualitzar
function obtenirObservacions(dadesObservacions) {
    return {
        type: OBSERVACIO_OBTENIR,
        dadesObservacions
    };
}

//obtenirObservacionsMapa: obtenirEstatsSeleccioData: Retorna l'objecte que rebrà el reducer
function obtenirEstats(dades) {
    return {
        type: OBSERVACIO_OBTENIR_ESTATS,
        estatsObservacions: dades
    };
}

function peticioObtenirObservacionsEnCurs() {
    return {
        type: OBSERVACIO_OBTENIR_EN_CURS
    };
}

function peticioInserirObservacioEnCurs() {
    return {
        type: OBSERVACIO_FORMULARI_INSERIR_EN_CURS
    };
}

function peticioInserirObservacioFinalitzada() {
    return {
        type: OBSERVACIO_FORMULARI_INSERIR_FINALITZADA
    };
}

function generarMissatgePerUsuariDespresDeInserirObservacio(estatAplicacio) {

    const estacioSeleccionada = obtenirEstacioSeleccionada(estatAplicacio);

    if (!estacioSeleccionada) {
        return '';
    }

    const nomEstacioSeleccionada = estacioSeleccionada.nom;
    const periodeSeleccionat = estatAplicacio.observacio.periodeSeleccionat;
    const nomPeriodeSeleccionat = obtenirNomMoment(periodeSeleccionat);

    const dataSeleccionadaText = convertirTextAMomentUTC(estatAplicacio.observacio.dataSeleccionada, MASCARA_YYYYMMDD).format(MASCARA_DDMMYYYY);

    const descripcio = `Per l'estació "${nomEstacioSeleccionada}" al ${nomPeriodeSeleccionat} amb data ${dataSeleccionadaText}.`;
    return descripcio;
}

/**
 *
 * @param dataSeleccionadaAsMoment {Moment}
 * @returns {{type: OBSERVACIO_DATA_SELECCIONADA, dataSeleccionada: String}}
 */
function seleccionarData(dataSeleccionadaAsMoment) {
    const dataSeleccionada = dataSeleccionadaAsMoment.format(MASCARA_YYYYMMDD);
    return {
        type: OBSERVACIO_DATA_SELECCIONADA,
        dataSeleccionada
    };
}



// WEBPACK FOOTER //
// ./src/actions/observacio.js